<template>

</template>

<script>

export default {
  name: 'Logout',
  data(router) {
    return {
      section: 'Logout',
      loading: '',
      password: '',
      response: '',
      email: ''
    }
  },
  mounted() {
    this.signOut()
  },
  methods: {
    signOut: function() {
      this.$store.commit('SET_TOKEN', null)
      this.$store.commit('SET_USER', null)
      this.$store.dispatch('logoutUser')
      this.$router.push('/login')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Logout.vue?cb7ecde8